const themeColor = {
  // Brand navy from the app's design kit (buttons, headers, active states).
  mainColor: "#224A9A",
  color2: "#A4B6D7",
  primary: "#224A9A",

  primary950: "#04103C",
  primary900: "#0A2067",
  primary800: "#142F63",
  primary700: "#1A3B78",
  primary600: "#1F4488",
  primary500: "#224A9A",
  primary400: "#4A6EAF",
  primary300: "#7692C3",
  primary200: "#A4B6D7",
  primary100: "#DCE7FD",
  primary50: "#EEF3FD",

  cyan950: "#021633",
  cyan900: "#001A3F",
  cyan800: "#00244C",
  cyan700: "#00335F",
  cyan600: "#004571",
  cyan500: "#005984",
  cyan400: "#2D91B5",
  cyan300: "#57C0DA",
  cyan200: "#91E5F2",
  cyan100: "#C7F5F8",
  cyan50: "#E4F5F6",

  blue950: "#172E54",
  blue900: "#1E478A",
  blue800: "#1E55AF",
  blue700: "#1D64D8",
  blue600: "#2570EB",
  blue500: "#3B82F6",
  blue400: "#609AFA",
  blue300: "#93BBFD",
  blue200: "#BFD7FE",
  blue100: "#DBE8FE",
  blue50: "#EFF5FF",

  green500: "#27AE60",
  green400: "#52BE80",
  green300: "#7DCEA0",
  green200: "#A9DFBF",
  green100: "#EAF7F0",

  maintext: "#1F2D3D",
  subtext: "#5A6B81",
  placeholder_inactive: "#F5F5F5",
  disable: "#D1D4DA",
  divider: "#EFF0F1",
  background: "#F8F9FA",
  white: "#FFFFFF",

  positive: "#27AE60",
  inprogress: "#3D7EFF",
  warning: "#F9A006",
  negative: "#F63737",

  red500: "#EB5757",
  red400: "#EF7979",
  red300: "#F39A9A",
  red200: "#F7BCBC",
  red100: "#FDEFEF",

  purple500: "#BB6BD9",
  purple400: "#C989E1",
  purple300: "#D6A6E8",
  purple200: "#E4C4F0",
  purple100: "#F9F1FC",

  yellow500: "#F9A006",
  yellow400: "#FBBE43",
  yellow300: "#FDD168",
  yellow200: "#FEE59B",
  yellow100: "#FFF2CB",
  /** Text on `yellow100`; `yellow500` is too light to read there. */
  yellow600: "#C98200",

  sGradient1: "#224A9A",
  sGradient2: "44.42deg, #2F80ED 5.76%, #82B3F4 100%",
  sGradient3: "44.42deg, #2F80ED 5.76%, #82B3F4 100%",

  sGradiantPrimary04: "rgba(164, 182, 215, 0.4)",
  sWhite75: "rgba(255, 255, 255, 0.75)",
  sWhite8: "rgba(255, 255, 255, 0.08)",

  lineCard: "#EFF1F5",
};

export const initialPage = {
  paddingX: "",
};
export default themeColor;
